import { useEffect, useRef, useState } from "react";
import { SocketProps } from "../types/interface";
import { useLocation, useNavigate } from "react-router-dom";
import { history } from "../history";
import Study from "../components/Study";
import { useRecoilState, useRecoilValue } from "recoil";
import { userRankingAtom } from "../atoms/userRankingAtom";
import FileTreeNew from "../components/FileTreeNew";
import { settedFileAtom } from "../atoms/settedFileAtom";
import { roomConfigAtom } from "../atoms/roomConfigAtom";
import { userStateAtom } from "../atoms/userStateAtom";
import axios from "axios";
import dayjs from "dayjs";
import { roomGameTypeAtom } from "../atoms/roomGameTypeAtom";
import { gametypeSaveAtom } from "../atoms/gametypeSaveAtom";
import { motion, AnimatePresence } from "framer-motion";
import { useCookies } from "react-cookie";

interface UserData {
  socketId: string;
  id: string;
  type: string;
  point: number;
  correct: number;
  wrong: number;
  results: string[];
  team: string;
  state: string;
  winningTeam?: string;
}

interface Config {
  type: string;
  use_time: number;
  count: number;
  occupants: number;
  start: string;
}

interface User {
  id: string;
  type: string;
  correct: number;
  wrong: number;
  point: number;
  team: string;
}

const Room: React.FC<SocketProps> = ({ socket }) => {
  const [cookies, setCookie, removeCookie] = useCookies(["startTime"]);
  const [users, setUsers] = useState<any>([]);
  const [selFiles, setSelFiles] = useState([]);
  const [config, setConfig] = useState<any>({});
  const [examCount, setExamCount] = useState<any>("");
  const [isStartSoon, setIsStartSoon] = useState(false);
  const [isStart, setIsStart] = useState(false);
  const [quesNum, setQuesNum] = useState(0);
  const [studyCount, setStudyCount] = useState(0);
  const startTime = useRef<string>("");
  const [roomGameType, setRoomGameType] = useRecoilState(roomGameTypeAtom);

  const [lastQuesObj, setLastQuesObj] = useState<any>();

  const location = useLocation();
  const navigate = useNavigate();
  const roomName = location.state.roomName;
  const id = location.state.id;
  const userData: any = users ? users.filter((x: any) => x.id === id)[0] : {};

  const [userRanking, setUserRanking] = useRecoilState(userRankingAtom);
  const [settedFile, setSettedFile] = useRecoilState(settedFileAtom);
  const [roomConfig, setRoomConfig] = useRecoilState(roomConfigAtom);

  const [userLoginState, setUserLoginState] = useRecoilState(userStateAtom);
  const userID = userLoginState.userData.userIdphp;
  const userRogedInId = userLoginState.userData.userIdphp;
  const [gameTypeAtom, setGameTypeAtom] = useRecoilState(gametypeSaveAtom);

  const enterCallBack = (roomObj: any, state: any) => {
    if (state === "room full") {
      alert("방이 꽉 찼습니다.");
      navigate("/");
      return;
    }
    // if (state === "already start") {
    //   alert("이미 시작하였습니다.");
    //   navigate("/fun_learning/home");
    //   return;
    // }
    console.log("enter callback");
    setUsers(roomObj.users);
    setSelFiles(roomObj.sel_files);
    setConfig(roomObj.config);
    setRoomGameType(roomObj.config.gameType);

    setIsStart(roomObj.isStart);
    if (roomObj.isStart) {
      startTime.current = cookies.startTime;
      setLastQuesObj(roomObj.quesList.slice(-1)[0]);
    }
  };

  useEffect(() => {
    socket.on("re_enter_room", (rooms) => {
      socket.emit("enter_room", roomName, id, enterCallBack);
    });
    socket.on("users", (users) => {
      //생성되어 있는 룸의 목록을 받아옴
      console.log("users", users);
      setUsers(users);
    });
    socket.on("room_list", (rooms) => {
      const targetRoom = rooms.filter((x: any) => x.name === roomName)[0];
      if (!targetRoom) {
        alert("방과의 연결이 끊어졌습니다.");
        navigate("/fun_learning/home");
        return;
      }
      setStudyCount(targetRoom.config.examCount);
    });
    socket.on("study_sel_change", (selFiles) => {
      setSelFiles(selFiles);
    });
    socket.on("start_ready", () => {
      setIsStartSoon(true);
    });
    socket.on("start_study", (count) => {
      const tmpStartTime = dayjs().format("YYYY-MM-DD HH:mm:ss");
      startTime.current = tmpStartTime;
      setCookie("startTime", tmpStartTime);
      setIsStartSoon(false);
      setIsStart(true);
      setStudyCount(count);
    });
    socket.on("make_ques", (quesObj) => {
      setIsStartSoon(false);
      setIsStart(true);
    });
    socket.on("end_study", (users: UserData[]) => {
      // console.log("------------------------------");
      // console.log("백엔드에 넘길것 파일:", settedFile);
      // console.log("백엔드에 넘길것 config:", roomConfig);
      // console.log("백엔드에 넘길 users:", users);
      // console.log("------------------------------");
      // console.log("룸컨피그", roomConfig);

      const configBack = {
        type: "basic",
        count: users[0].correct + users[0].wrong,
        occupants: roomConfig.count,
        start: startTime.current,
        use_time: dayjs().diff(dayjs(startTime.current), "second"),
      };

      const usersBackSolo = users
        .filter((user) => user.id === userRogedInId)
        .map(({ socketId, results, state, ...rest }) => rest);

      //같이 하면 될듯
      const usersBack = users.map(
        ({ socketId, results, state, ...rest }) => rest
      );

      const fileBack = [settedFile];

      // console.log("------------------------------");
      // console.log("백엔드에 넘길것 다듬은 config:", configBack);
      // console.log("백엔드에 넘길 다듬은 users:", usersBack);
      // console.log("백엔드에 넘길 다듬은 user:", usersBackSolo);
      // console.log("백엔드에 넘길 다듬은 userId:", usersBackSolo[0].id);
      // console.log("백엔드에 넘길 다듬은 point:", usersBackSolo[0].point);
      // console.log("백엔드에 넘길것 다듬은 파일:", fileBack);
      // console.log("------------------------------");

      const userIdMoney = usersBackSolo[0].id;
      const userPointMoney = Math.floor(usersBackSolo[0].point / 5);

      const sendPostRequest = async (
        configBack: Config,
        usersBack: User[],
        fileBack: string[]
      ) => {
        try {
          console.log({
            config: JSON.stringify(configBack),
            users: JSON.stringify(usersBack),
            files: JSON.stringify(fileBack),
          });
          const response = await axios.post(
            "https://chamstudyland.com/api/fun_learning/record.php",
            {
              config: JSON.stringify(configBack),
              users: JSON.stringify(usersBack),
              files: JSON.stringify(fileBack),
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          // console.log("Response:", response.data);
        } catch (error) {
          console.error("Error:", error);
        }
      };

      const sendPostRequestMoney = async (
        userId: string,
        userVolume: number
      ) => {
        try {
          const response = await axios.post(
            "https://chamstudyland.com/api/fun_learning/change_money.php",
            {
              id: userId,
              volume: userVolume,
            },
            {
              headers: {
                "Content-Type": "multipart/form-data",
              },
            }
          );

          // console.log("Response:", response.data);
        } catch (error) {
          console.error("Error:", error);
        }
      };

      if (usersBackSolo[0].type === "owner") {
        sendPostRequest(configBack, usersBack, fileBack);
      }

      // console.log("머니에 넘길 userid", userIdMoney);
      // console.log("머니에 넘길 money", userPointMoney);

      sendPostRequestMoney(userIdMoney, userPointMoney);

      setUserRanking(users);
      setIsStart(false);
      setUsers([]);
      setSelFiles([]);
      setExamCount(0);
      setIsStartSoon(false);
      setQuesNum(0);
      setStudyCount(0);
      setLastQuesObj(null);
      //   exitRoom();
      // console.log("게임 타입이야", roomConfig.gameType);
      if (roomConfig.gameType === "4" || gameTypeAtom === "4") {
        setConfig({});
        navigate("/fun_learning/showrankingsuccess", { replace: true });
      } else {
        setConfig({});
        navigate("/fun_learning/showranking", { replace: true });
      }
    });

    socket.emit("enter_room", roomName, id, enterCallBack);

    // [
    //     {
    //         "socketId": "J85Eumq11U_2f4qlAAAT",
    //         "id": "kim04091",
    //         "type": "owner",
    //         "point": 15,
    //         "correct": 3,
    //         "wrong": 0,
    //         "results": [
    //             "correct",
    //             "correct",
    //             "correct"
    //         ],
    //         "team": "",
    //         "state": ""
    //     }
    // ]
    return () => {
      socket.off("re_enter_room");
      socket.off("users");
      socket.off("room_list");
      socket.off("study_sel_change");
      socket.off("start_ready");
      socket.off("start_study");
      socket.off("end_study");
      socket.off("make_ques");
    };
  }, []);

  const exitRoom = () => socket.emit("exit_room");
  useEffect(() => {
    const unlistenHistoryEvent = history.listen(({ action }) => {
      if (action === "POP") {
        exitRoom();
      }
    });

    return unlistenHistoryEvent;
  }, []);

  useEffect(() => {
    if (!userData || userData.type !== "owner") return;
    socket.emit("set_exam_count", roomName, examCount);
  }, [examCount]);

  const start = () => {
    if (isStartSoon) return;
    if (examCount < 6) {
      window.alert("6문제 이상을 선택해야 시작할 수 있습니다.");
      return;
    }
    if (config.gameType === "1" || config.gameType === "2")
      socket.emit("start_study", roomName);
    else if (config.gameType === "4") {
      const filtered = (users as any[]).filter(
        (user: any) => user.knowWords.length < examCount
      );
      if (filtered.length > 0) {
        window.alert(`성공한단어가 ${examCount}개보다 적은 인원이 있습니다.`);
      } else {
        socket.emit("basic/know/start", roomName);
      }
    }
  };

  const changeTeam = (userObj: any, team: any) => {
    if (userObj.type === "owner" && !config.ownerParticipate) return;
    socket.emit("change_team", roomName, userObj.id, team);
  };

  const sortedUsers = users.slice().sort((a: any, b: any) => b.point - a.point); //랭킹 정렬 코드

  const rankingData = sortedUsers.slice(0, 6);

  const findIndexById = (arr: any[], targetId: any): number => {
    return arr.findIndex((item: any) => item.id === targetId);
  };

  const findEntryNumById = (arr: any[], targetId: any): string | undefined => {
    const foundItem = arr.find((item: any) => item.id === targetId);
    return foundItem ? foundItem.entryNum : undefined;
  };

  const currentRanking = findIndexById(sortedUsers, userID);

  const myRankinId = findEntryNumById(sortedUsers, userID);

  const handleChange = (e: any) => {
    const value: any = e.target.value;
    setExamCount(value === "" ? "" : Number(value));
  };

  return (
    <div className="h-fit dark:bg-gray-700 bg-gray-200 pt-12 pb-5 text-slate-700 dark:text-slate-200">
      <div className="max-w-sm sm:max-w-5xl mx-auto bg-white dark:bg-gray-900 rounded-lg overflow-hidden shadow-lg mb-6">
        <div className="text-center p-3 text-3xl">
          <div>{`교실이름: ${roomName}`}</div>
          <div className="text-lg">
            {" "}
            {roomConfig.pw === "" || !roomConfig.pw
              ? ""
              : `비밀번호:${roomConfig.pw}`}
          </div>
          <div className="px-2 inline-flex text-lg leading-5 font-semibold rounded-full bg-pink-100 text-pink-800 dark:bg-pink-700 dark:text-pink-200 mr-1">
            {config.gameType === "1"
              ? "개인전"
              : config.gameType === "2"
              ? "팀전"
              : config.gameType === "4"
              ? "성공한단어"
              : "Loading..."}
          </div>
        </div>

        <div>
          <div className="mb-3">
            <span className="p-3 text-xl">참가자 목록</span>
            {config.maxUser > 0 && (
              <span className="mr-3 px-2 inline-flex text-lg leading-5 font-semibold rounded-full bg-purple-100 text-purple-800 dark:bg-purple-700 dark:text-purple-200">
                {users.length} / {config.maxUser}
              </span>
            )}
          </div>
          <AnimatePresence>
            <div className="h-32 overflow-y-auto lg:grid lg:grid-cols-2">
              {sortedUsers
                ? sortedUsers.map((user: any, index: number) => {
                    const userState = user.results[quesNum];
                    const userNumber = users.length;
                    let userStateTxt = "";
                    if (userState === "correct") userStateTxt = "정답";
                    else if (userState === "wrong") userStateTxt = "오답";

                    return (
                      <motion.div
                        key={user.id}
                        layout
                        initial={{ opacity: 0, y: -20 }}
                        animate={{ opacity: 1, y: 0 }}
                        exit={{ opacity: 0, y: 20 }}
                        transition={{ duration: 0.5 }}
                        className="text-lg px-3"
                      >
                        <span className="mt-1 bg-slate-200 inline-flex font-bold items-center border-2 border-transparent outline-none focus:ring-1 focus:ring-offset-2 focus:ring-link active:bg-link active:text-gray-700 active:ring-0 active:ring-offset-0 leading-normal bg-link text-gray-700 hover:bg-opacity-80 text-base rounded-lg py-1 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700">
                          {`${user.entryNum} ${user.id}`}
                        </span>
                        <span className="px-2">
                          {user.id === config.owner ? (
                            <span className="mt-1 bg-slate-200 inline-flex font-bold items-center border-2 border-transparent outline-none focus:ring-1 focus:ring-offset-2 focus:ring-link active:bg-link active:text-gray-700 active:ring-0 active:ring-offset-0 leading-normal bg-link text-gray-700 hover:bg-opacity-80 text-base rounded-lg py-1 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700">
                              👑반장
                              {config.ownerParticipate ? " 참여" : " 불참"}
                            </span>
                          ) : (
                            <span className="mt-1 bg-slate-200 inline-flex font-bold items-center border-2 border-transparent outline-none focus:ring-1 focus:ring-offset-2 focus:ring-link active:bg-link active:text-gray-700 active:ring-0 active:ring-offset-0 leading-normal bg-link text-gray-700 hover:bg-opacity-80 text-base rounded-lg py-1 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700">
                              🧑‍💻user
                            </span>
                          )}
                        </span>
                        <span>
                          {" "}
                          {isStart ? (
                            <span>
                              <span className="mt-1 mr-1 bg-slate-200 inline-flex font-bold items-center border-2 border-transparent outline-none focus:ring-1 focus:ring-offset-2 focus:ring-link active:bg-link active:text-gray-700 active:ring-0 active:ring-offset-0 leading-normal bg-link text-gray-700 hover:bg-opacity-80 text-base rounded-lg py-1 dark:bg-gray-800 dark:text-gray-300 dark:hover:bg-gray-700">
                                <span>{user.point}점</span>
                                <span className="ml-1"> 🏆{index + 1}등</span>
                              </span>
                              <span>
                                {userStateTxt ? (
                                  userStateTxt === "정답" ? (
                                    <span className="text-blue-500 m-1 font-bold">
                                      맞았어요!
                                    </span>
                                  ) : (
                                    <span className="text-pink-600 m-1 font-bold">
                                      틀렸어요!
                                    </span>
                                  )
                                ) : (
                                  ""
                                )}
                              </span>
                            </span>
                          ) : (
                            ""
                          )}
                        </span>

                        <span>
                          {userData.id === config.owner &&
                          config.gameType === "2" ? (
                            <div style={{ display: "inline" }}>
                              <button
                                className="px-2 inline-flex text-lg leading-5 font-semibold rounded-full bg-pink-100 text-pink-800 dark:bg-pink-700 dark:text-pink-200"
                                onClick={() => changeTeam(user, "A")}
                              >
                                A팀
                              </button>
                              <button
                                className="px-2 inline-flex text-lg leading-5 font-semibold rounded-full bg-pink-100 text-blue-800 dark:bg-blue-700 dark:text-blue-200"
                                onClick={() => changeTeam(user, "B")}
                              >
                                B팀
                              </button>
                            </div>
                          ) : (
                            ""
                          )}
                        </span>
                        <span className="text-2xl mr-2">
                          {" "}
                          {user.team === "" || config.gameType !== "2"
                            ? ""
                            : ` ${user.team} 팀 입니다`}
                        </span>
                        <span>
                          {config.gameType === "4"
                            ? ` 성공한단어: ${user.knowCount}개`
                            : ""}
                        </span>
                      </motion.div>
                    );
                  })
                : ""}
            </div>
          </AnimatePresence>
        </div>
        {userData &&
        userData.type === "owner" &&
        !isStart &&
        config.gameType !== "4" ? (
          <div className="flex flex-col lg:flex-row">
            <FileTreeNew id={id} socket={socket} roomName={roomName} />
            {isStart ? (
              ""
            ) : (
              <div className="bg-slate-100 dark:bg-slate-700 rounded-md m-3 p-3 h-64 overflow-y-auto">
                <div className="text-xl font-bold ">학습 목록</div>
                <div>
                  {selFiles
                    ? selFiles.map((file: any) => {
                        return (
                          <div
                            className="px-3 pt-1 bg-blue-200 dark:bg-blue-500 m-1 rounded-md flex align-middle"
                            key={file.value}
                          >
                            {file.folderName} - {file.name} ({file.count})
                          </div>
                        );
                      })
                    : ""}
                </div>
              </div>
            )}
          </div>
        ) : (
          ""
        )}

        {isStart ? (
          <div className="mt-3">
            <div className="text-lg px-3">
              <AnimatePresence>
                <div className="flex">
                  {rankingData
                    ? rankingData.map((user: any, index: any) => {
                        return (
                          <motion.div
                            key={user.entryNum}
                            layout
                            initial={{ opacity: 0, y: -20 }}
                            animate={{ opacity: 1, y: 0 }}
                            exit={{ opacity: 0, y: 20 }}
                            transition={{ duration: 0.5 }}
                            className="font-bold dark:text-blue-500 text-blue-700 dark:border dark:border-blue-500 rounded-full w-12 h-12 m-1 flex justify-center items-center bg-slate-300 dark:bg-slate-800 shadow-xl"
                          >
                            {user.entryNum}
                          </motion.div>
                        );
                      })
                    : ""}
                </div>
              </AnimatePresence>
            </div>
          </div>
        ) : (
          ""
        )}

        {isStart ? (
          <AnimatePresence>
            <div className="text-center p-3 text-xl">
              <motion.div
                initial={{ opacity: 0, y: -10 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: 10 }}
                transition={{ duration: 0.5 }}
              >{`랭킹ID:${myRankinId} 🏆${currentRanking + 1}위`}</motion.div>
            </div>
          </AnimatePresence>
        ) : (
          ""
        )}

        {isStart ? (
          <Study
            socket={socket}
            roomName={roomName}
            id={id}
            lastQuesObj={lastQuesObj}
            setMainQuesNum={setQuesNum}
            studyCount={studyCount}
            isParticipate={userData.type !== "owner" || config.ownerParticipate}
            config={config}
          />
        ) : (
          <div className="m-5 px-3 ">
            {userData && userData.type === "owner" ? (
              <div>
                <div className="mb-3">
                  <div className="mb-1 mt-3 text-xl font-bold">문제수</div>
                  <input
                    className="dark:bg-slate-500 bg-white shadow-sm rounded-lg p-3 w-52 border border-gray-300 dark:border-gray-600 focus:outline-none focus:ring-2 focus:ring-indigo-500 focus:border-indigo-500"
                    type="number"
                    value={examCount}
                    onChange={handleChange}
                    placeholder="Enter number of questions"
                    min="1"
                    max="40"
                  />
                </div>

                <div className="flex flex-col gap-5">
                  <div>
                    <button
                      onClick={start}
                      className="mr-3 mt-3 inline-block text-center px-20 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-pink-600 to-pink-500 hover:bg-gradient-to-b dark:shadow-pink-900 shadow-pink-200 hover:shadow-2xl hover:shadow-pink-400 hover:-tranneutral-y-px "
                    >
                      {isStartSoon ? "곧 시작합니다 준비하세요." : "시작하기"}
                    </button>
                  </div>
                  <div>
                    <span className="p-3 text-xl font-bold">참가자 수</span>
                    <span className="mr-3 px-2 inline-flex text-lg leading-5 font-semibold rounded-full bg-purple-100 text-purple-800 dark:bg-purple-700 dark:text-purple-200">
                      {`${
                        config.ownerParticipate
                          ? users.length
                          : users.length - 1
                      } / 
              ${config.maxUser}`}
                    </span>
                  </div>
                </div>
              </div>
            ) : (
              ""
            )}
            {userData && userData.type !== "owner" ? (
              <button className="mt-3 inline-block w-auto text-center min-w-[200px] px-6 py-4 text-white transition-all rounded-md shadow-xl sm:w-auto bg-gradient-to-r from-pink-600 to-pink-500 hover:bg-gradient-to-b dark:shadow-pink-900 shadow-pink-200 hover:shadow-2xl hover:shadow-pink-400 hover:-tranneutral-y-px ">
                {isStartSoon
                  ? "곧 시작합니다 준비하세요."
                  : "아직 반장이 시작하지 않았습니다."}
              </button>
            ) : (
              ""
            )}
          </div>
        )}
      </div>
    </div>
  );
};

export default Room;
